<template>
  <div class="mb-12" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-3'">
    <v-dialog v-model="dialog.review" persistent max-width="400">
      <v-card class="pa-3">
        <div class="title text--secondary mb-5">Tambah Review</div>
        <ValidationObserver ref="observer">
          <v-form>
            <ValidationProvider
              name="Nama" 
              rules="required" 
              v-slot="{ errors }">
              <v-text-field
                dense
                outlined
                label="Nama"
                color="#ff618a"
                v-model="review.name"
                :error-messages="errors"
                require>
              </v-text-field>
            </ValidationProvider>
            <ValidationProvider
              name="Pekerjaan" 
              rules="required" 
              v-slot="{ errors }">
              <v-text-field
                dense
                outlined
                label="Pekerjaan"
                color="#ff618a"
                v-model="review.job"
                :error-messages="errors"
                require>
              </v-text-field>
            </ValidationProvider>
            <ValidationProvider
              name="Alamat" 
              rules="required" 
              v-slot="{ errors }">
              <v-text-field
                dense
                outlined
                label="Alamat"
                color="#ff618a"
                v-model="review.location"
                :error-messages="errors"
                require>
              </v-text-field>
            </ValidationProvider>
            <quill-editor 
              :ref="`myTextEditorReview`" 
              v-model="review.desc" 
              :options="option">
            </quill-editor>
            <p
              class="caption text-left mt-1 red--text"
              v-show="error.reviewDesc">
              {{ error.reviewDesc }}
            </p>
            <div class="mb-3">
              <p class="mb-1">Gambar</p>
              <form>
                <v-card flat width="220" class="pa-0" style="background: transparent;">
                  <image-input v-model="avatar" type="uploadCover">
                    <div slot="activator">
                      <v-avatar tile size="100" height="100" class="grey lighten-3 cursor-pointer" v-ripple>
                        <v-icon v-if="!avatar && addImage === ''" color="grey darken-3" large>mdi-camera</v-icon>
                        <div class="px-5" v-if="addImage && avatar.url === undefined">
                          <v-progress-linear
                            color="#ff618a"
                            indeterminate
                            rounded
                            height="6"
                            class="mx-4 mt-4"
                            style="width: 80px;">
                          </v-progress-linear>
                          <p class="mt-2 mx-4 mb-0" style="font-size: 9px;">
                            Mengupload Gambar . . .
                          </p>
                        </div>
                        <img v-if="avatar && !addImage"
                          :src="review.image" 
                          :alt="review.image" 
                          width="200"
                          height="200"/>
                      </v-avatar>
                    </div>
                  </image-input>
                </v-card>
              </form>
              <p
                class="caption text-left mt-1 red--text"
                v-show="error.reviewImage">
                {{ error.reviewImage }}
              </p>
            </div>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn
                small
                rounded
                width="100"
                color="#FF618A"
                elevation="0"
                @click="addReview"
                class="white--text text-capitalize">
                Simpan
              </v-btn>
              <v-btn
                rounded
                small
                width="100"
                elevation="0"
                class="text-capitalize"
                @click="resetReview">
                Batal
              </v-btn>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="12" sm="12">
        <v-row>
          <v-col cols="12" sm="7" class="pb-0">
            <div class="title text--secondary">Landing Page</div>
          </v-col>
          <v-col cols="12" sm="5" class="text-right pb-0 px-5">
            <v-btn
              :color="!showPage ? '#FF618A' : '#F5F5F5'"
              width="200"
              class="text-capitalize"
              :dark="!showPage"
              elevation="0"
              rounded
              :block="$vuetify.breakpoint.name === 'xs' ? true : false"
              :disabled="process.form || process.run"
              :light="showPage"
              v-on:click="showPage ? showPage = false : showPage = true">
              <span v-if="!showPage">Ubah Landing Page</span>
              <span v-if="showPage">Kembali</span>
            </v-btn>
          </v-col>
        </v-row>
        <div class="my-2" v-if="!showPage" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'ma-2' : ''">
          <v-card flat class="align-center line-content my-5 py-4">
            <div 
              v-if="process.run">
              <v-skeleton-loader
                v-for="item in 10" :key="item"
                ref="skeleton"
                type="list-item-two-line"
                class="mx-auto">
              </v-skeleton-loader>
            </div>
            <v-list dense v-if="!process.run">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="body-2 font-weight-bold grey--text text--darken-2">
                    Section 
                  </v-list-item-title>
                  <div class="mt-2 subtitle-2 font-weight-light" v-html="form.home.title"></div>
                  <div class="mt-2 subtitle-2 font-weight-light" v-html="form.home.desc"></div>
                </v-list-item-content>
              </v-list-item>
              <v-img :src="form.banner.urlImage"></v-img>

              <v-divider class="ma-5"/>

              <v-card-text class="body-2 font-weight-bold grey--text text--darken-2">
                Visi Misi
              </v-card-text>
              <v-img :src="form.vm.urlImage" width="350" height="200"></v-img>

              <v-divider class="ma-5"/>

              <v-card-text class="body-2 font-weight-bold grey--text text--darken-2">
                Testimoni
              </v-card-text>
              <v-card-text>
                <v-carousel :show-arrows="true" hide-delimiters v-model="model" height="auto">
                  <v-carousel-item
                    v-for="(review, i) in form.review"
                    :key="i">
                    <v-card
                      class="mx-2 box-shadow"
                      width="100%"
                      height="auto" 
                      light
                      flat>
                      <v-row justify="space-around" class="pa-5" align="center">
                        <v-col :cols="$vuetify.breakpoint.name === 'sm'? 3:12" md="3">
                          <div class="bg-frame text-center" style="position:relative">
                            <v-avatar :size="$vuetify.breakpoint.name === 'xs'? 100 : 200">
                              <v-img
                              :style="$vuetify.breakpoint.name === 'xs'? 'margin: auto;width: 150px;':'width:230px;'"
                              :src="review.image">
                              </v-img>
                            </v-avatar>
                          </div>
                        </v-col>
                        <v-col :cols="$vuetify.breakpoint.name === 'sm'? 7:12" md="6">
                          <div>
                            <div>
                              <v-img :src="require('../../../assets/icon/cite-right.svg')" width="50">
                              </v-img>
                            </div>
                            <p class="caption text-second line-text-second my-5" v-html="convert(review.desc)"></p>
                            <div class="text-right mb-3">
                            <v-img :src="require('../../../assets/icon/cite-left.svg')" style="margin-left:auto" width="50"></v-img>
                            </div>
                          </div>
                          <div class="mb-1">
                            <span class="headline-2 color-default font-weight-bold">
                              {{ review.name }}
                            </span>
                          </div>
                          <div>
                            <span class="c-hazel" style="font-size:13px;">
                              {{ review.job }} - {{ review.location }}
                            </span>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-carousel-item>
                </v-carousel>
              </v-card-text>

              <v-divider class="ma-5"/>

              <v-card-text class="body-2 font-weight-bold grey--text text--darken-2">
                Galery
              </v-card-text>
              <v-card-text class="px-0">
                <v-slide-group
                  prev-icon="mdi-chevron-left-circle"
                  next-icon="mdi-chevron-right-circle"
                  center-active
                  show-arrows>
                  <v-slide-item
                    v-for="(item, index) in form.galery"
                    :key="index"
                    v-slot:default="{ toggle }">
                    <v-card
                      class=" mx-2 box-shadow"
                      width="100%"
                      height="300" 
                      outlined
                      @click="toggle">
                      <v-img
                        width="100%"
                        height="300" 
                        :src="item"
                        gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)">
                        <v-icon color="white" style="position: absolute; top: 5px; right: 5px;" @click="removeImage(index)">mdi-close-circle</v-icon>
                      </v-img>
                    </v-card>
                  </v-slide-item>
                </v-slide-group>
              </v-card-text>

              <v-divider class="ma-5"/>

              <v-card-text class="body-2 font-weight-bold grey--text text--darken-2">
                Video
              </v-card-text>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <video
                      id="myVideo"
                      height="200px"
                      width="100%" 
                      playsinline 
                      controls
                      :src="form.video.videoUrl">
                    </video>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <div>
                       <v-card-text v-html="form.video.title"></v-card-text>
                    </div>
                    <v-card-text v-html="form.video.desc"></v-card-text>
                  </v-col>
                   <!-- <v-col cols="12" sm="6">
                    <v-card-text v-html="form.video.title"></v-card-text>
                  </v-col> -->
                </v-row>
              </v-card-text>

            </v-list>
          </v-card>
        </div>
      </v-col>
      <v-col 
        cols="12" 
        sm="12" 
        class="mt-6 background-default pa-7" v-if="showPage">
        <div class="title text--secondary mb-5">Ubah Landing Page</div>
        <ValidationObserver ref="observer">
          <v-form>
            <!-- HOME -->
            <p class="mb-1">
              Konten
            </p>
            <div v-if="form.home">
              <p class="caption text--secondary mb-1">
                Judul Section 
              </p>
              <quill-editor 
                :ref="`myTextEditorHomeTitle`" 
                v-model="form.home.title" 
                :options="option">
              </quill-editor>
              <p class="caption text--secondary mt-5 mb-1">
                Deskripsi Section 
              </p>
              <quill-editor 
                :ref="`myTextEditorHomeDesc`" 
                v-model="form.home.desc" 
                :options="option">
              </quill-editor>
            </div>

            <div class="mt-5">
              <div class="mb-3">
                <p class="caption text--secondary mb-1">
                Banner
                </p>
                <form class="mt-1">
                  <v-card flat width="100%" height="250" class="pa-0" style="background: transparent;">
                    <image-input v-model="banner" type="uploadCover">
                      <div slot="activator">
                        <v-avatar tile size="100%" height="250" class="grey lighten-3 cursor-pointer" v-ripple>
                          <v-icon v-if="!banner" color="grey darken-3" large>mdi-camera</v-icon>
                          <img v-else :src="form.banner.urlImage" :alt="form.banner.urlImage" />
                        </v-avatar>
                      </div>
                    </image-input>
                  </v-card>
                </form>
              </div>
            </div>

            <!-- VISI MISI -->
            <p class="mb-1 mt-8">
              Visi Misi
            </p>
            <div>
              <div class="mb-3">
                <p class="caption text--secondary mb-1">
                Gambar
                </p>
                <form class="mt-1">
                  <v-card flat width="350" height="200" class="pa-0" style="background: transparent;">
                    <image-input v-model="vmImage" type="uploadCover">
                      <div slot="activator">
                        <v-avatar tile size="350" height="200" class="grey lighten-3 cursor-pointer" v-ripple>
                          <v-icon v-if="!vmImage" color="grey darken-3" large>mdi-camera</v-icon>
                          <img v-else :src="form.vm.urlImage" :alt="form.vm.urlImage" />
                        </v-avatar>
                      </div>
                    </image-input>
                  </v-card>
                </form>
              </div>
            </div>

            <div>
              <p class="mb-1 mt-8">
                Testimoni
              </p>
              <v-card-text class="px-0 pt-0">
                <v-btn
                  small
                  color="#FF3177"
                  elevation="3"
                  class="text-capitalize white--text mx-1"
                  @click="dialog.review = true">
                  <v-icon small class="mr-1">mdi-plus</v-icon>
                  Tambah Testimoni
                </v-btn>
              </v-card-text>

              <v-card-text class="px-0">
                <v-carousel :show-arrows="true" hide-delimiters v-model="model" height="auto">
                  <v-carousel-item
                    v-for="(review, i) in form.review"
                    :key="i">
                    <v-card
                      class="mx-2 box-shadow"
                      width="100%"
                      height="auto" 
                      light>
                      <v-row justify="space-around" class="pa-5" align="center">
                        <v-col :cols="$vuetify.breakpoint.name === 'sm'? 3:12" md="3">
                          <div class="bg-frame text-center" style="position:relative">
                            <v-avatar :size="$vuetify.breakpoint.name === 'xs'? 100 : 200">
                              <v-img
                              :style="$vuetify.breakpoint.name === 'xs'? 'margin: auto;width: 150px;':'width:230px;'"
                              :src="review.image">
                              </v-img>
                            </v-avatar>
                          </div>
                        </v-col>
                        <v-col :cols="$vuetify.breakpoint.name === 'sm'? 7:12" md="6">
                          <v-icon style="position: absolute; top: 10px; right: 15px;" @click="removereview(i)">mdi-close-circle</v-icon>
                          <div>
                            <div>
                              <v-img :src="require('../../../assets/icon/cite-right.svg')" width="50">
                              </v-img>
                            </div>
                            <p class="caption text-second line-text-second my-5" v-html="convert(review.desc)"></p>
                            <div class="text-right mb-3">
                            <v-img :src="require('../../../assets/icon/cite-left.svg')" style="margin-left:auto" width="50"></v-img>
                            </div>
                          </div>
                          <div class="mb-1">
                            <span class="headline-2 color-default font-weight-bold">
                              {{ review.name }}
                            </span>
                          </div>
                          <div>
                            <span class="c-hazel" style="font-size:13px;">
                              {{ review.job }} - {{ review.location }}
                            </span>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-carousel-item>
                </v-carousel>
              </v-card-text>

            </div>

            <div>
              <p class="mb-1 mt-8">
                Galery
              </p>
              <v-card-text class="px-0 pt-0">
                <image-input v-model="galery">
                  <div slot="activator">
                    <v-btn
                      small
                      color="#FF3177"
                      elevation="3"
                      class="text-capitalize white--text mx-1">
                      <v-icon small class="mr-1">mdi-image-plus</v-icon>
                      Tambah Gambar
                    </v-btn>
                  </div>
                </image-input>
              </v-card-text>

              <v-card-text class="px-0">
                <v-slide-group
                  prev-icon="mdi-chevron-left-circle"
                  next-icon="mdi-chevron-right-circle"
                  center-active
                  show-arrows>
                  <v-slide-item
                    v-for="(item, index) in form.galery"
                    :key="index"
                    v-slot:default="{ toggle }">
                    <v-card
                      class=" mx-2 box-shadow"
                      width="100%"
                      height="300" 
                      outlined
                      @click="toggle">
                      <v-img
                        width="100%"
                        height="300" 
                        :src="item"
                        gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)">
                        <v-icon color="white" style="position: absolute; top: 5px; right: 5px;" @click="removeImage(index)">mdi-close-circle</v-icon>
                      </v-img>
                    </v-card>
                  </v-slide-item>
                </v-slide-group>
              </v-card-text>

            </div>

            <div v-if="form.video">
              <p class="mb-2 mt-8">
                Video
              </p>

              <p class="caption text--secondary mb-1">
                Title 
              </p>
               <quill-editor 
                :ref="`myTextEditorReviewTitle`" 
                v-model="form.video.title" 
                :options="option"
                class="mb-2">
              </quill-editor>

              <p class="caption text--secondary mb-1">
                Deskripsi 
              </p>
              <quill-editor 
                :ref="`myTextEditorReview`" 
                v-model="form.video.desc" 
                :options="option">
              </quill-editor>
              <form class="mt-3">
                <v-card
                flat
                width="400"
                height="250"
                class="pa-0"
                style="background: transparent;"
                >
                <video-input v-model="video">
                  <div slot="activator">
                    <v-avatar
                    width="400"
                    max-width="340"
                    height="220"
                    class="grey lighten-3 cursor-pointer"
                    v-ripple
                    tile
                    v-if="!video || video.url === undefined">
                    <v-icon v-if="!video && addVideo === ''" color="grey darken-3" large>mdi-video-plus</v-icon>
                    <div v-if="addVideo && video.url === undefined">
                      <v-progress-linear
                        color="#ff618a"
                        indeterminate
                        rounded
                        height="6"
                        style="width: 200px;">
                      </v-progress-linear>
                        <p class="caption mt-2 mb-0">
                          Mengupload video . . .
                        </p>
                    </div>
                    </v-avatar>
                  </div>
                </video-input>
                <video
                  id="myVideo"
                  height="200px"
                  width="100%" 
                  :src="form.video.videoUrl"
                  playsinline 
                  controls
                  v-if="video && !addVideo">
                </video>
                <video-input v-model="video" >
                  <div slot="activator">
                    <v-btn
                      rounded
                      light
                      width="100%"
                      color="#ff618a"
                      elevation="0"
                      :disabled="addVideo || process.run"
                      :loading="addVideo"
                      v-if="addVideo !== '' && video.url !== undefined"
                      class="white--text text-capitalize">
                      Ganti Video
                    </v-btn>
                  </div>
                </video-input>
                </v-card>
              </form>
            </div>

            <v-card-actions class="mt-3">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                light
                width="200"
                color="#FF618A"
                elevation="0"
                :disabled="process.form"
                :loading="process.form"
                @click="save"
                class="white--text text-capitalize">
                Simpan
              </v-btn>
            </v-card-actions>

          </v-form>
        </ValidationObserver>
      </v-col>
    </v-row>
  </div>
</template>
<script>
  import { get, post, put, destroy } from "../../../service/Axios";
  import ImageInput from "../../../components/ImageInput.vue";
  import Empty from "../../../components/DataEmpty";
  import VideoInput from "../../../components/VideoInput.vue";
  export default {
    data() {
      return {
        option: {
          modules: {
            toolbar: [
              ["bold", "italic", "underline"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ color: [] }, { background: [] }],
              [{ align: [] }]
            ]
          },
          placeholder: 'Deskripsi . . .'
        },
        dialog:{
          form: false,
          review: false
        },
        showPage: false,
        addVideo: "",
        video: null,
        model: 0,
        review: {
          name: "",
          desc: "",
          job: "",
          location: "",
          image: ""
        },
        form: {
          home : {
            title : "",
            desc : ""
          },
          banner: {
            urlImage: ""
          },
          vm : {
            urlImage: ""
          },
          galery: [],
          review: [],
          video: {
            desc: "",
            videoUrl: "",
            title:""
          }
        },
        error: {
          reviewDesc: "",
          reviewImage: ""
        },
        process: {
          form: false,
          run: false
        },
        addImage: "",
        vmImage:null,
        banner: null,
        galery: null,
        avatar: null,
        response: ""
      };
    },
    watch: {
      galery: {
        handler: function () {
          if (this.galery.url !== undefined) {
            this.form.galery.push(this.galery.url)
          }
        },
        deep: true
      },
      vmImage: {
        handler: function () {
          this.form.vm.urlImage = this.vmImage.url ? this.vmImage.url : ""
          this.error.urlImage = ''
        },
        deep: true
      },
      banner: {
        handler: function () {
          this.form.banner.urlImage = this.banner ? this.banner.url : ""
          this.error.banner = ''
        },
        deep: true
      },
      avatar: {
        handler: function () {
          this.review.image = this.avatar ? this.avatar.url : ""
          this.addImage = this.avatar.add === undefined ? "" : this.avatar.add
          this.error.reviewImage = ''
        },
        deep: true
      },
      video: {
        handler: function() {
          this.form.video.videoUrl = this.video.url;
          this.addVideo = this.video.add
        },
        deep: true,
      },
    },
    components: {
      ImageInput,
      Empty,
      VideoInput,
    },
    mounted() {
      window.scrollTo(0, 0);
      this.fetch();
    },
    methods: {
      async fetch() {
        this.process.run = true
        await get(`api/internal/lp/detail/5f7d889e2e63aa1bdd68769a`)
        .then(response => {
          let res = response.data
          if (res.code === 200) {
            this.form = {}
            this.process.run = false
            this.form = res.data.content
            console.log(this.form)
            console.log('data res',res)
            this.banner = {
              url : this.form.banner.urlImage
            }
            this.vmImage = {
              url: this.form.vm.urlImage
            }
            this.form.home.title = this.convert(this.form.home.title)
            this.form.home.desc = this.convert(this.form.home.desc)
            this.form.video.desc = this.convert(this.form.video.desc)
            this.form.video.title = this.convert(this.form.video.title)
            this.video = {
              url : this.form.video.videoUrl
            }
          }
        })
      },
      convert(item) {
        return item.replace(/&lt;/g, '<')
      },
      removeImage(index) {
        this.form.galery.splice(index, 1)
      },
      removereview(index) {
        this.form.review.splice(index, 1)
      },
      resetReview () {
        this.dialog.review = false
        this.$refs.observer.reset()
        this.review = {
          name: "",
          desc: "",
          image: "",
          job: "",
          location: ""
        }
      },
      async addReview () {
        const valids = this.validation();
        const isValid = await this.$refs.observer.validate();
        if (isValid && valids) {
          this.form.review.push(
            {
              name: this.review.name,
              desc: this.review.desc,
              image: this.review.image,
              job: this.review.job,
              location: this.review.location
            }
          )
          this.resetReview()
          this.avatar = ""
          this.addImage = ""
          this.$refs.observer.reset()
        }
      },
      validation() {
        var error = this.error,
          valid = true
        
        if (this.review.desc === "") {
          error.reviewDesc = "Kolom tidak boleh kosong"
          valid = false
        } else {
          error.reviewDesc = ""
        }

        if (this.review.image === "") {
          error.reviewImage = "Gambar tidak boleh kosong"
          valid = false
        } else {
          error.reviewImage = ""
        }

        return valid;
      },
      async save() {
        this.response = ""
        this.process.form = true
        await put(`api/internal/lp/update/5f7d889e2e63aa1bdd68769a`, {
          data: {content : this.form},
        }).then(response => {
          let res = response.data
          if (res.code === 201) {
            this.process.form = false
            this.showPage = false
            this.dialog.form = false
            this.fetch()
          } else {
            this.process.form = false
            this.response = res.msg
          }
        })
      }
    }
  }
</script>

<style scoped>
  .line-content {
    border-left: 6px solid  #FF618A;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
      0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;
    transition: 0.3s;
  }
</style>